import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 22px;\n  margin: 0;\n\n  @media screen and (max-width: ", "px) {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 16px;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 600;\n  line-height: 22px;\n  font-size: 14px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: ", "px;\n  margin: 0 auto;\n  box-sizing: border-box;\n\n  @media screen and (max-width: ", "px) {\n    padding: 0 30px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          opacity: ", ";\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          visibility: hidden;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 16px;\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    height: ", "px;\n\n    &:before {\n      content: '';\n      position: fixed;\n      left: 0;\n      z-index: 0;\n      height: inherit;\n      right: 0;\n      background-color: rgba(255, 255, 255, ", ");\n      box-shadow: 0px 1px 0px rgba(0, 0, 0, ", ");\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 104px;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  top: 80px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n\n  @media screen and (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n  @media screen and (min-width: ", "px) {\n    padding: 0 60px;\n  }\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import { ActionButton } from '../ActionButton';
import { BACK_BUTTON } from '../utils/testing/TestIDs';
import styled, { css } from '../utils/styling/styled-components';
import { ACTION_STRIP_SUBTEXT, ACTION_STRIP_TITLE } from '../utils/testing/TestIDs';
import { theme } from '../theme';
import { Heading2, Title } from '../Typography';
import { useStickyScroll } from '../ActionStrip/hooks';
import { ActionStripButtonV2 } from './ActionStripButton';
var Wrapper = styled.div(_templateObject());
var Container = styled.div(_templateObject2(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return !props.isSBNavEnabled && 'top: 70px;';
}, function (props) {
  return css(_templateObject3(), 104 - (104 - 64) * props.scrollPercent, props.scrollPercent, props.scrollPercent * 0.05);
}, theme.breakpoints.md + 1, function (props) {
  return props.isSBNavEnabled && 'top: 0px';
});
var Content = styled.div(_templateObject4());
var TitleArea = styled.div(_templateObject5(), function (props) {
  switch (props.visibilityMode) {
    case 'none':
      return css(_templateObject6());

    case 'onscroll':
      return css(_templateObject7(), props.scrollPercent);

    default:
      return '';
  }
});
var InnerContainer = styled.div(_templateObject8(), function (props) {
  return props.maxWidth;
}, function (props) {
  return props.theme.breakpoints.md;
});
var Subtitle = styled(Heading2)(_templateObject9(), theme.colors.stone);
var StyledTitle = styled(Title)(_templateObject10(), theme.colors.slate, theme.breakpoints.sm);
export var DesktopStripV2 = function DesktopStripV2(_ref) {
  var title = _ref.title,
      subtext = _ref.subtext,
      action = _ref.action,
      actions = _ref.actions,
      onBack = _ref.onBack,
      backIcon = _ref.backIcon,
      titleVisibility = _ref.titleVisibility,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth,
      className = _ref.className,
      _ref$titleTestId = _ref.titleTestId,
      titleTestId = _ref$titleTestId === void 0 ? ACTION_STRIP_TITLE : _ref$titleTestId,
      _ref$subtextTestId = _ref.subtextTestId,
      subtextTestId = _ref$subtextTestId === void 0 ? ACTION_STRIP_SUBTEXT : _ref$subtextTestId,
      _ref$showBackButton = _ref.showBackButton,
      showBackButton = _ref$showBackButton === void 0 ? true : _ref$showBackButton,
      isSBNavEnabled = _ref.isSBNavEnabled;

  var _useStickyScroll = useStickyScroll({
    scrollDistance: 64
  }),
      scrollPercent = _useStickyScroll.scrollPercent;

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, {
    isSBNavEnabled: isSBNavEnabled,
    scrollPercent: scrollPercent,
    className: className
  }, /*#__PURE__*/React.createElement(InnerContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement(Content, null, showBackButton && /*#__PURE__*/React.createElement(ActionStripButtonV2, {
    testId: BACK_BUTTON,
    icon: backIcon ? /*#__PURE__*/React.createElement(AcornsIcon, {
      icon: backIcon,
      width: "24px",
      height: "24px"
    }) : /*#__PURE__*/React.createElement(AcornsIcon, {
      icon: AcornsIcon.Icon.ArrowLeft,
      width: "17px",
      height: "12px"
    }),
    actionText: "Go back",
    onPress: onBack
  }), /*#__PURE__*/React.createElement(TitleArea, {
    scrollPercent: scrollPercent,
    visibilityMode: titleVisibility
  }, title && /*#__PURE__*/React.createElement(StyledTitle, {
    "data-testid": titleTestId
  }, title), subtext && /*#__PURE__*/React.createElement(Subtitle, {
    "data-testid": subtextTestId
  }, " ", subtext))), action && action, actions === null || actions === void 0 ? void 0 : actions.map(function (action) {
    return /*#__PURE__*/React.createElement(ActionButton, {
      key: action.id,
      icon: action.icon,
      text: actions.length > 4 ? null : action.text,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }))));
};